import * as React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const Footer = styled.footer`
  padding: 1rem;
  background-color: #ffc107;
  color: black;
  ul {
    list-style-type: none;
    margin-left: -2rem;
  }
  a {
    color: black;
    text-decoration: none;
    transition: ease-in-out 0.25s;
    &:hover {
      color: #1e429f;
    }
  }
`;

const FooterComponent = () => {
  return (
    <Footer className="container-fluid">
      <div className="row">
        <div className="col-12 col-md-3">
          <Link to="/" className="no-underline text-sm">
            {new Date().getFullYear()} &copy; Smartywak
          </Link>
        </div>

        <div className="col-12 col-md-3">
          <h4 className="mb-8">Information</h4>
          <ul>
            <li>
              <Link to="/om-oss/">Om oss</Link>
            </li>
            {/* Content marketing after 10 approved customers monthly through non-organic means */}
            {/* <li>
              <Link to="/blogg/">Blogg</Link>
            </li> */}
            <li>
              <Link to="/om-oss/kommersiellt-meddelande/">
                Kommersiellt meddelande
              </Link>
            </li>
            <li>
              <Link to="/cookie-policy/">Cookie Policy</Link>
            </li>
          </ul>
        </div>
        <div className="col-12 col-md-3">
          <h4 className="mb-8">Våra tjänster</h4>
          <ul>
            {/* <li className="mb-2">
              <Link to="/lana-pengar/">Låna pengar</Link>
            </li> */}
            <li className="mb-2">
              <Link to="/billan">Billån</Link>
            </li>
            <li className="mb-2">
              <Link to="/samla-lan">Samla lån</Link>
            </li>
            <li className="mb-2">
              <Link to="/privatlan">Privatlån</Link>
            </li>
            <li className="mb-2">
              <Link to="/omstartslan">Omstartslån</Link>
            </li>
            {/* 
            <li className="mb-2">
              <Link to="/lan-utan-sakerhet/">Lån utan säkerhet</Link>
            </li> */}
          </ul>
        </div>
        <div className="col-12 col-md-3">
          <h4 className="mb-8">Populära lånebelopp</h4>
          <ul>
            {/* <li className="mb-2">
              <Link to="/lanebelopp/lana-5000/">Låna 5 000 kronor</Link>
            </li> */}
            {/* <li className="mb-2">
              <Link to="/lanebelopp/lana-10000/">Låna 10 000 kronor</Link>
            </li> */}
            {/* <li className="mb-2">
              <Link to="/lanebelopp/lana-50000/">Låna 50 000 kronor</Link>
            </li> */}
            {/* <li className="mb-2">
              <Link to="/lanebelopp/lana-100000/">Låna 100 000 kronor</Link>
            </li> */}
            {/* <li className="mb-2">
              <Link to="/lanebelopp/lana-200000/">Låna 200 000 kronor</Link>
            </li> */}
            {/* <li className="mb-2">
              <Link to="/lanebelopp/lana-400000/">Låna 400 000 kronor</Link>
            </li> */}
            {/* <li className="mb-2">
              <Link to="/lanebelopp/lana-500000/">Låna 500 000 kronor</Link>
            </li> */}
            <li>
              <Link to="/lanebelopp/lana-600000">Låna 600 000 kronor</Link>
            </li>
          </ul>
        </div>
      </div>
    </Footer>
  );
};

export default FooterComponent;
